export const dateToLocaleString = (date: string) => {
    return date ? new Date(date).toLocaleString() : '';
};
